/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfFeedbackAttachmentContentDto } from '../../models/platform-api-result-of-feedback-attachment-content-dto';

export interface GetFeedbackAttachmentsId$Params {
  id: string;
}

export function getFeedbackAttachmentsId(http: HttpClient, rootUrl: string, params: GetFeedbackAttachmentsId$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfFeedbackAttachmentContentDto>> {
  const rb = new RequestBuilder(rootUrl, getFeedbackAttachmentsId.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfFeedbackAttachmentContentDto>;
    })
  );
}

getFeedbackAttachmentsId.PATH = '/api/feedback/attachments/{id}';
